import { useCallback, useState } from "react";
import DefaultButton from "./DefaultButton";
import { Col, Row } from "./Grid"
import { GuideButton } from "./GuideButton";
import PopoutButton from "./PopoutButton";
import { usePanel } from "./DesktopContext";
import { useApp } from "./AppProvider";

const PanelTitle = ({ title, guide, onPopout, onPin, onUnpin, children }) => {
    const { isApp } = useApp();
    const panelInfo = usePanel();
    const [pinned, setPinned] = useState(false);

    const togglePinned = useCallback(() => setPinned(pinned => {
        pinned ? onUnpin() : onPin();
        return !pinned;
    }), [onUnpin, onPin]);

    return !panelInfo?.hideTitle && <div className="py-2 px-2" style={{ position: 'sticky', top: '0px', backgroundColor: 'white', zIndex: 10 }}>
        <Row>
            <Col xs="auto" className="pr-2">
                <Row>
                    {onPin && onUnpin && <Col className="mx-1" xs="auto"><DefaultButton kind={pinned ? 'unpin' : 'pin'} onClick={togglePinned}></DefaultButton></Col>}
                    <Col xs="auto"><h4 className="mb-0">{panelInfo?.title ?? title}</h4></Col>
                    {
                        !isApp && onPopout && <Col className="mx-1 py-0" xs="auto"><PopoutButton onClick={onPopout}></PopoutButton></Col>
                    }
                    <Col className="mx-1 py-0">
                    <GuideButton style={{ marginTop: '-2px' }} guide={guide}></GuideButton>
                    </Col>
                </Row>
            </Col>
            <Col className="d-flex flex-grow-1 justify-content-end align-items-start">{children}</Col>
        </Row>
    </div>
}

export default PanelTitle;